exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".landing-hero-image.small-hero>.background-image{height:400px}@media(max-width: 575px){.landing-hero-image.small-hero>.background-image{height:250px}}.landing-hero-image.small-hero>.content-section .hero-content{min-height:400px}.landing-hero-image.small-hero>.content-section .hero-content .text-wrapper{height:400px}@media(max-width: 575px){.landing-hero-image.small-hero>.content-section .hero-content .text-wrapper{height:250px}.landing-hero-image.small-hero>.content-section .hero-content .text-wrapper .text{margin-top:95px}}.landing-hero-image.small-hero>.content-section .hero-content .hero-form{margin-top:105px;margin-bottom:15px}@media(max-width: 575px){.landing-hero-image.small-hero>.content-section .hero-content .hero-form{margin-top:20px}}.landing-hero-image.small-hero>.content-section .hero-content .hero-form .basic-info-about-me{width:415px}@media(max-width: 575px){.landing-hero-image.small-hero>.content-section .hero-content .hero-form .basic-info-about-me{width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/PolicyReview/Landing.scss
// module id = 8063
// module chunks = 13